import { encode } from "js-base64";
//#region src/v2/blocks/scalar-auth-selector-block/helpers/oauth-client-authorization.ts
/** Encode OAuth client passwords using form encoding before Basic authentication (RFC6749 section 2.3.1). */
var oauthClientAuthorization = (clientId, clientSecret) => {
	const formEncode = (value) => new URLSearchParams({ value }).toString().slice(6);
	return `Basic ${encode(`${formEncode(clientId)}:${formEncode(clientSecret)}`)}`;
};
//#endregion
export { oauthClientAuthorization };

//# sourceMappingURL=oauth-client-authorization.js.map